import { ListenableEvent } from "../../utils";
import { InteractionMode } from "./Tool";
export class AbstractTool {
    constructor(pApp) {
        this.eventStarted = new ListenableEvent(this);
        this.eventStopped = new ListenableEvent(this);
        this.mApp = pApp;
        this.mIsRunning = false;
        this.mInteractionMode = InteractionMode.None;
    }
    isAvailable() {
        return (true);
    }
    isRunning() {
        return (this.mIsRunning);
    }
    getInteractionMode() {
        return (this.mInteractionMode);
    }
    start(pParameter) {
        this.mIsRunning = true;
        this.eventStarted.trigger();
        return (true);
    }
    stop() {
        this.mIsRunning = false;
        this.mInteractionMode = InteractionMode.None;
        this.eventStopped.trigger();
        return;
    }
    handlePointerDown(pEvent, pState) {
    }
    handlePointerUp(pEvent, pState) {
    }
    handlePointerDblClick(pEvent, pState) {
    }
    handlePointerMove(pEvent, pState) {
    }
    handlePointerCancel(pEvent, pState) {
        this.handlePointerUp(pEvent, pState);
    }
    handleKeyUp(pEvent, pState) {
    }
    setInteractionMode(pMode) {
        this.mInteractionMode = pMode;
    }
}
